.s-count-down{
  &-wrapper{
    
  }
  &-boxed{

  }
  &-ended{
    
  }
  &-list{

  }
  &-item{

  }
  &-item{
    &-value{

    }
    &-label{

    }
  }
  &-end-text{

  }
}